import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../services/configuration.service';
import { AppHttpService } from '../../services/app-http.service';
import { AauthService } from '../../services/aauth.service';

declare function InitMyJs(): void;                                                                                      // fake to skip ide error.

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  constructor(
    public configurationService: ConfigurationService,
    private appHttp: AppHttpService,
    private aAuthService: AauthService,
  ) { }

  ngOnInit(): void {
    try {
      InitMyJs();
    } catch (error) {
      console.error(error);
    }
  }
}
